import React from 'react'
import { JoinForm } from '../../components/JoinForm'

export const JoinPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#EDE6DE]">
      <div className="container mx-auto">
        <JoinForm />
      </div>
    </div>
  )
}
